import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { RouteMapModalComponent } from 'src/app/modules/request-form/pages/route-map-modal/route-map-modal.component';

@Component({
  selector: 'app-periodic-popup',
  templateUrl: './periodic-popup.component.html',
  styleUrls: ['./periodic-popup.component.scss'],
})
export class PeriodicPopupComponent {
  popupForm!: FormGroup;
  list: { key: string; index: number }[] = [];
  fileContent: string | ArrayBuffer | null = null;
  uploadedFile: any;
  selectedFiles: File[] = [];
  nextStep: boolean = false;
  uploadedFileName: any;
  isAutoCompleteOn: boolean = false;
  warrantedOptions = ['YES', 'NO'];
  periodicId: boolean = false;
  routesData: any = null;
  isLoadingMap: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PeriodicPopupComponent>,
    private fb: FormBuilder,
    private requestFormService: RequestFormService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.popupForm = this.fb.group({});
  }
  ngOnInit(): void {
    const base64File = localStorage.getItem('uploadedFile');
    const id = localStorage.getItem('periodicId');
    if (id) {
      this.periodicId = true;
    }
    if (base64File) {
      // Convert the base64 string back to a file object
      this.uploadedFileName = localStorage.getItem('uploadedFileName');
      this.uploadedFile = this.base64ToFile(base64File, this.uploadedFileName);
    }
    
    // Fetch configuration
    this.requestFormService
      .uploadPeriodicReport([this.uploadedFile])
      .subscribe({
        next: (res) => {
          this.setFormFromApi(res);
        },
      });

    // Fetch Route Preview for Map View
    this.isLoadingMap = true;
    this.requestFormService.getRoutePreview({ files: [this.uploadedFile], report_type: 'periodic' }).subscribe({
      next: (res) => {
        this.isLoadingMap = false;
        if (res && res.routes) {
          this.routesData = res.routes;
        }
      },
      error: (err) => {
        this.isLoadingMap = false;
        console.error('Route preview failed', err);
      }
    });
  }
  setFormFromApi(result: any) {
    const legs = Object.keys(result).sort((a, b) => {
      const numA = parseInt(a.replace('leg', ''));
      const numB = parseInt(b.replace('leg', ''));
      return numA - numB;
    });
    this.list = [];

    legs.forEach((legKey, index) => {
      const legData = result[legKey];

      this.popupForm.addControl(
        'startDate' + index,
        new FormControl(legData.start_date)
      );
      this.popupForm.addControl(
        'endDate' + index,
        new FormControl(legData.end_date)
      );
      this.availableExcludedDates[index] = [...legData.excluded_date].sort(
        (a, b) => new Date(a).getTime() - new Date(b).getTime()
      );
      this.popupForm.addControl('excludedDates' + index, new FormControl([]));

      this.popupForm.addControl('warrantedLeg' + index, new FormControl(''));
      this.popupForm.addControl('reason' + index, new FormControl(''));

      this.list.push({ key: legKey, index });
    });
  }

  convertToDateInputFormat(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Extract only YYYY-MM-DD
  }

  base64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mimeMatch = arr[0].match(/:(.*?);/);

    if (!mimeMatch) {
      throw new Error('Invalid base64 string format');
    }

    const mime = mimeMatch[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  onSubmit(confirmed: any) {
    if (confirmed === 'performance') {
      let result: any = {};

      this.list.forEach(({ key, index }) => {
        result[key.toLowerCase()] = {
          start_date: this.popupForm.get('startDate' + index)?.value,
          end_date: this.popupForm.get('endDate' + index)?.value,
          excluded_dates: this.getFormattedExcludedDates(index),
          warranted_leg: this.popupForm.get('warrantedLeg' + index)?.value,
        };
      });
      this.dialogRef.close(result);
      console.log(result, 'result......');
    } else if (confirmed === 'periodic') {
      let result: any = {};

      this.list.forEach(({ key, index }) => {
        result[key.toLowerCase()] = {
          start_date: this.popupForm.get('startDate' + index)?.value,
          end_date: this.popupForm.get('endDate' + index)?.value,
          excluded_dates: this.getFormattedExcludedDates(index),
          warranted_leg: this.popupForm.get('warrantedLeg' + index)?.value,
        };
      });
      this.requestFormService
        .generatePeriodicReport(result, this.uploadedFile,this.data)
        .subscribe((data) => {
          console.log(data);
          this.toastr.success(
            'Periodic Report has been successfully Generated.'
          );
        });
      this.dialogRef.close();
    } else {
      this.dialogRef.close();
    }
  }
  getFormattedExcludedDates(index: number): any[] {
    const selectedExcludedDates =
      this.popupForm.get('excludedDates' + index)?.value || [];
    const allDates = this.availableExcludedDates[index] || [];
    const reasonControlValue =
      this.popupForm.get('reason' + index)?.value || '';

    return allDates.map((date, i) => {
      const selected = selectedExcludedDates.find(
        (item: any) => item.date === date
      );
      if (selected) {
        return selected;
      }

      const reasonField = {
        reason: i === 0 ? reasonControlValue : '',
      };

      return {
        date,
        report_type: 'noon',
        ...reasonField,
      };
    });
  }

  getFormControl(name: string): FormControl {
    return this.popupForm.get(name) as FormControl;
  }

  dropdownOpenIndex: number | null = null;
  availableExcludedDates: { [index: number]: string[] } = {}; // Store dynamic dates per leg

  toggleDropdown(index: number) {
    this.dropdownOpenIndex = this.dropdownOpenIndex === index ? null : index;
  }

  isChecked(option: string, selectedOptions: any[]): boolean {
    if (!selectedOptions || selectedOptions.length === 0) return false;

    return selectedOptions.some(
      (item) => item.date === option && item.report_type === 'exclude'
    );
  }

  toggleSelection(option: string, index: number) {
    const control = this.getFormControl('excludedDates' + index);
    let selectedOptions = control.value || [];

    // Check if the date is already selected
    const existingIndex = selectedOptions.findIndex(
      (item: any) => item.date === option
    );

    if (existingIndex !== -1) {
      // Date is already selected; remove it and revert to default
      selectedOptions[existingIndex] = {
        date: option,
        report_type: 'noon',
        reason: '',
      };
    } else {
      // Date is newly selected; add it with exclude properties
      selectedOptions.push({
        date: option,
        report_type: 'exclude',
        reason: '',
      });
    }

    control.setValue(selectedOptions);
  }

  getSelectedText(selectedOptions: any[]): string {
    if (!selectedOptions || selectedOptions.length === 0) {
      return 'Select Excluded Dates';
    }

    // Extract only the date values for display
    return selectedOptions.map((option) => option.date).join(', ');
  }

  openMapModal(legKey: string) {
    if (!this.routesData || !this.routesData[legKey]) {
      this.toastr.warning('Map data not available for this leg yet');
      return;
    }
    
    // We pass only the routes for the specific leg
    const specificLegRoutes = this.routesData[legKey];
    // Reconstruct into an object matching the format RouteMapModalComponent expects if it expects `{ routes: [...] }`
    // We must pass an object that matches what the modal consumes. 
    // In Voyage Report, `routesData` is an array of GeoJSONs. 
    // Here, `this.routesData[legKey]` is already the array of GeoJSON lines for this leg.
    this.dialog.open(RouteMapModalComponent, {
      width: '80%',
      height: '80%',
      data: { routes: { [legKey]: specificLegRoutes } }
    });
  }
}
